import React from 'react';
import { Modal, ModalHeader, ModalBody, Button, Row, Col, Badge } from 'reactstrap';
import { Settings, ChefHat, ArrowRight, LayoutGrid, ListOrdered } from 'lucide-react';

const THEME_COLOR = '#c59253';

const ExperienceChoiceModal = ({ isOpen, toggle, onSelectSetup, onSelectDistribution, onSelectSpaceManagement }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size="lg" className="experience-choice-modal">
            <ModalHeader toggle={toggle} className="border-0 pb-0">
                <div className="text-center w-100">
                    <h4 className="fw-bold mb-1">Select Wizard Experience</h4>
                    <p className="text-muted small mb-0">Choose the workflow you want to configure today.</p>
                </div>
            </ModalHeader>
            <ModalBody className="p-4">
                <Row className="g-4">
                    <Col md={4}>
                        <div
                            className="experience-card p-4 rounded-4 border border-2 h-100 transition-all cursor-pointer hover-shadow d-flex flex-column"
                            onClick={onSelectSetup}
                            style={{ borderColor: '#f3f3f3' }}
                        >
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <div className="p-3 bg-soft-primary rounded-3 text-primary">
                                    <ChefHat size={24} />
                                </div>
                                <Badge color="soft-primary" className="text-uppercase" style={{ fontSize: '10px' }}>Quick Start</Badge>
                            </div>
                            <h5 className="fw-bold mb-2">Menu & Site Setup</h5>
                            <p className="text-muted small mb-4 flex-grow-1">Perfect for new restaurants. Build your menu and get a QR code in minutes.</p>
                            <ul className="list-unstyled small mb-4">
                                <li className="mb-2 d-flex align-items-center gap-2"><ArrowRight size={14} className="text-primary" />Business & Site Info</li>
                                <li className="mb-2 d-flex align-items-center gap-2"><ArrowRight size={14} className="text-primary" />Full Menu Builder</li>
                                <li className="d-flex align-items-center gap-2"><ArrowRight size={14} className="text-primary" />Automated Space mapping</li>
                            </ul>
                            <Button color="primary" block className="rounded-pill mt-auto">Start Menu Wizard</Button>
                        </div>
                    </Col>

                    <Col md={4}>
                        <div
                            className="experience-card p-4 rounded-4 border border-2 h-100 transition-all cursor-pointer hover-shadow d-flex flex-column"
                            onClick={onSelectSpaceManagement}
                            style={{ borderColor: '#f3f3f3' }}
                        >
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <div className="p-3 bg-soft-warning rounded-3 text-warning">
                                    <LayoutGrid size={24} />
                                </div>
                                <Badge color="soft-warning" className="text-uppercase" style={{ fontSize: '10px' }}>Advanced</Badge>
                            </div>
                            <h5 className="fw-bold mb-2">Space Management</h5>
                            <p className="text-muted small mb-4 flex-grow-1">Manage multiple branches, map specific table layouts, and bulk-print QR codes.</p>
                            <ul className="list-unstyled small mb-4">
                                <li className="mb-2 d-flex align-items-center gap-2"><ArrowRight size={14} className="text-warning" />Multi-Location Manager</li>
                                <li className="mb-2 d-flex align-items-center gap-2"><ArrowRight size={14} className="text-warning" />Interactive Pin Drops</li>
                                <li className="d-flex align-items-center gap-2"><ArrowRight size={14} className="text-warning" />Space Distribution</li>
                            </ul>
                            <Button color="warning" block className="rounded-pill text-white mt-auto">Manage Spaces</Button>
                        </div>
                    </Col>

                    {/* <Col md={4}>
                        <div
                            className="experience-card p-4 rounded-4 border border-2 h-100 transition-all cursor-pointer hover-shadow d-flex flex-column"
                            onClick={onSelectDistribution}
                            style={{ borderColor: '#f3f3f3' }}
                        >
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <div className="p-3 bg-soft-success rounded-3 text-success">
                                    <ListOrdered size={24} />
                                </div>
                                <Badge color="soft-success" className="text-uppercase" style={{ fontSize: '10px' }}>Efficiency</Badge>
                            </div>
                            <h5 className="fw-bold mb-2">Station Assignment</h5>
                            <p className="text-muted small mb-4 flex-grow-1">Configure kitchen printers and dispatch logic for your service zones.</p>
                            <ul className="list-unstyled small mb-4">
                                <li className="mb-2 d-flex align-items-center gap-2"><ArrowRight size={14} className="text-success" />Station Mapping</li>
                                <li className="mb-2 d-flex align-items-center gap-2"><ArrowRight size={14} className="text-success" />Routing Dispatcher</li>
                                <li className="d-flex align-items-center gap-2"><ArrowRight size={14} className="text-success" />Performance Rules</li>
                            </ul>
                            <Button color="success" block className="rounded-pill mt-auto">Enter Distribution</Button>
                        </div>
                    </Col> */}
                </Row>
            </ModalBody>
            <style>
                {`
                    .experience-card:hover {
                        border-color: ${THEME_COLOR} !important;
                        transform: translateY(-5px);
                        box-shadow: 0 10px 30px rgba(0,0,0,0.05);
                    }
                    .bg-soft-primary { background-color: rgba(64, 81, 137, 0.1); }
                    .bg-soft-success { background-color: rgba(10, 179, 156, 0.1); }
                    .bg-soft-warning { background-color: rgba(247, 184, 75, 0.1); }
                    .text-primary { color: #405189 !important; }
                    .text-success { color: #0ab39c !important; }
                    .text-warning { color: #f7b84b !important; }
                `}
            </style>
        </Modal>
    );
};

export default ExperienceChoiceModal;
